import { render, staticRenderFns } from "./OTitle.vue?vue&type=template&id=3194de9a&"
import script from "./OTitle.vue?vue&type=script&lang=js&"
export * from "./OTitle.vue?vue&type=script&lang=js&"
import style0 from "./OTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports